// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tBgR","content":"styles_content__2zWXX","row":"styles_row__38C4O","footer":"styles_footer__1Pe2o","phraseLength":"styles_phraseLength__1kuFo"};